import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import emailSentImage from '../images/check-your-email-open-letter.svg';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

const imgHeight = 88;

const EmailSentImageContainer = styled.div`
  background: url(${emailSentImage}) no-repeat center bottom;
  height: ${imgHeight}px;
  margin: ${gridSize()}px 0 ${gridSize() * 2}px;
`;

const EmailSentDescriptionContainer = styled.div`
  text-align: left;
`;

const EmailWarningContainer = styled.div`
  text-align: left;
  margin-top: ${gridSize() * 2}px;
`;

const Email = styled.p`
  font: ${token('font.heading.small')};
  text-align: left;
  overflow-wrap: break-word;
  & {
    margin-top: ${gridSize()}px;
  }
`;

export default function EmailSent(props: {
  children?: React.ReactNode;
  email?: string;
  message?: React.ReactNode;
  warningMessage?: React.ReactNode;
  onRender?: () => void;
  withEmailSentImage?: boolean;
}) {
  const { children, email, message, warningMessage, onRender, withEmailSentImage = true } = props;

  useEffect(() => {
    if (onRender) {
      onRender();
    }
  }, [onRender]);

  return (
    <div id="email-sent-page">
      {withEmailSentImage && <EmailSentImageContainer />}
      <EmailSentDescriptionContainer>{message}</EmailSentDescriptionContainer>
      {email && <Email>{email}</Email>}
      {warningMessage && <EmailWarningContainer>{warningMessage}</EmailWarningContainer>}
      {children}
    </div>
  );
}
